export default __webpack_public_path__ + "static/media/Thumb_Bottom_04.cc76e3d5.png";